import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "@environments/environment";
import { Observable } from "rxjs";
import { TypeOrganizations } from "@app/screens/set-organizations/store/typeorganizations.models";
import {lowerCase} from "lodash-es";
import {AccountService} from "@app/services/account.service";
import { Organization } from "@app/screens/set-organizations/store/organizations.models";

const baseUrl = 'http://localhost:8000/api/v1/organizations';

@Injectable({
  providedIn: 'root'
})
export class OrganizationsService {
  constructor (private http: HttpClient, private accountService: AccountService) {}

  getAll(search?:string, pagination: boolean = true, finished?:boolean) {
    const queryParams = [
      finished ? 'finished=1' : '',           // Si 'finished' es true, incluye el filtro
      pagination ? `pagination=1` : 'pagination=0',       // Incluye la página solo si la paginación está habilitada
    ]
      .filter(param => param)                 // Elimina cualquier parámetro vacío
      .join('&');  
    
      return this.http.get<any>(`${environment.api.auth}/${this.accountService.language}/api/v1/organizations/organizations/?${queryParams}`);
  }
  getAllMercha(search?:string, pagination: boolean = true, finished?:boolean) {
    const queryParams = [
      finished ? 'finished=1' : '',           // Si 'finished' es true, incluye el filtro
      pagination ? `pagination=1` : 'pagination=0',       // Incluye la página solo si la paginación está habilitada
      'merchandising=1'                       // Siempre incluir el filtro de merchandising
    ]
      .filter(param => param)                 // Elimina cualquier parámetro vacío
      .join('&');  
    
      return this.http.get<any>(`${environment.api.auth}/${this.accountService.language}/api/v1/organizations/organizations/?${queryParams}`);
  }


  getMerchandisingAll(page=1, search: string = '', basic=true) : Observable<Organization[]>{
      return this.http.get<Organization[]>(`${environment.api.auth}/${this.accountService.language}/api/v1/organizations/organizations/?page=${page}&search=${search}&merchandising=1&admin=1&serializer=${basic?'basic': ''}`);
  }

  getAllPage(page:number=1) {
    return this.http.get<any>(`${environment.api.auth}/${this.accountService.language}/api/v1/organizations/organizations/?page=${page}`);
  }
  getDetail(id: any) {
    return this.http.get<any>(`${environment.api.auth}/${this.accountService.language}/api/v1/organizations/organizations/${id}/`);
  }

  getTypeOrganization() {
    return this.http.get<any>(`${environment.api.auth}/${this.accountService.language}/api/v1/organizations/org-types/`);
  }

  getCities() {
    return this.http.get(`${environment.api.auth}/${this.accountService.language}/api/v1/geolocation/city/`);
  }

  createOrganization(form?:any) {
    let schema_name = lowerCase(form.schema_name);

    const bodyStruct = {
      name: form.name,
      domain_url: form.domain_url,
      alias: form.alias,
      city: form.city,
      organization_id_number: form.organization_id_number,
      organization_type: form.organization_type,
      link_bi_marketing: form.link_bi_marketing,
      link_bi_sales: form.link_bi_sales,
      enabled_merchandising: !!form.enabled_merchandising,
      workdays: {
        '0': form.workdays_sun? true: false,
        '1': form.workdays_mon? true: false,
        '2': form.workdays_tue? true: false,
        '3': form.workdays_wen? true: false,
        '4': form.workdays_thu? true: false,
        '5': form.workdays_fri? true: false,
        '6': form.workdays_sat? true: false,
        'h': form.workdays_hol? true: false
      }
    }
    return this.http.post(`${environment.api.auth}/${this.accountService.language}/api/v1/organizations/organizations/`, bodyStruct);
  }
  updateOrganization(id: any, form?:any) {
    const bodyStruct = {
      name: form.name,
      domain_url: form.domain_url,
      alias: form.alias,
      city: form.city,
      organization_id_number: form.organization_id_number,
      organization_type: form.organization_type,
      link_bi_marketing: form.link_bi_marketing,
      link_bi_sales: form.link_bi_sales,
      workdays: {
        '0': form.workdays_sun? true: false,
        '1': form.workdays_mon? true: false,
        '2': form.workdays_tue? true: false,
        '3': form.workdays_wen? true: false,
        '4': form.workdays_thu? true: false,
        '5': form.workdays_fri? true: false,
        '6': form.workdays_sat? true: false,
        'h': form.workdays_hol? true: false
      }
    }
    return this.http.patch(`${environment.api.auth}/${this.accountService.language}/api/v1/organizations/organizations/${id}/`, bodyStruct);
  }
  deleteOrganization(id: any) {
    return this.http.delete(`${environment.api.auth}/${this.accountService.language}/api/v1/organizations/organizations/${id}/`);
  }
}
